import React, { type FC, type ReactNode } from 'react'

import { objectEntries, type PartialReadonlyRecord, type ReadonlyRecord } from '../../../utils'

import { Translation } from '../../../domain'

import type { AbsoluteRouteOnlyPath } from '../routing'
import { RouteTabs } from '../Tabs'
import { NewRoleButton, NewUserButton } from './Buttons'
import { tabs } from './Config'
import { Filter } from './Filter'

const documentation = {
    documentationTitle: Translation.USERS_AND_ROLES_DOCUMENTATION_TITLE,
    documentationBody: Translation.USERS_AND_ROLES_DOCUMENTATION_BODY,
} as const

const titleActions: ReadonlyRecord<keyof typeof tabs, ReactNode> = {
    users: (
        <>
            <Filter />
            <NewUserButton />
        </>
    ),
    roles: (
        <>
            <Filter />
            <NewRoleButton />
        </>
    ),
    permissions: <Filter />,
}

type RouteTab = typeof documentation & Readonly<{ titleActions: ReactNode }>

const routeTabs = objectEntries(tabs).reduce<PartialReadonlyRecord<AbsoluteRouteOnlyPath, RouteTab> & ReadonlyRecord<string, RouteTab>>(
    (r, [tab, path]) => ({ ...r, [path]: { ...documentation, titleActions: titleActions[tab] } }),
    {}
)

export const UserManagementTabs: FC = () => <RouteTabs title={Translation.USERS_AND_ROLES} tabs={routeTabs} />
